import React from 'react';
import { Button } from '../buttons';

const figmaLogoDesktop = process.env.PUBLIC_URL + '/assets/figma-logo-desktop.svg';
const figmaLogoMobile = process.env.PUBLIC_URL + '/assets/figma-logo-mobile.svg';
const menuIcon = process.env.PUBLIC_URL + '/assets/menu-icon.svg';

const Header: React.FC = () => {
  return (
    <>
      {/* Desktop Header - exact Figma layout */}
      <header className="hidden desktop:block bg-background-default border-b border-border-default w-full">
        <div className="w-device-desktop mx-auto px-800 py-800 flex items-center gap-600">
          {/* Logo */}
          <div className="flex items-center gap-600 shrink-0">
            <img 
              src={figmaLogoDesktop} 
              alt="Figma Logo" 
              className="h-[35px] w-[40px]"
            />
          </div>

          {/* Navigation - flex-1 to fill space */}
          <nav className="flex-1 flex justify-end">
            <div className="flex items-center gap-200">
              <Button label="Products" variant="subtle" size="small" />
              <Button label="Solutions" variant="subtle" size="small" />
              <Button label="Community" variant="subtle" size="small" />
              <Button label="Resources" variant="subtle" size="small" />
              <Button label="Pricing" variant="subtle" size="small" />
              <Button label="Contact" variant="subtle" size="small" />
              <Button label="Link" variant="subtle" size="small" />
            </div>
          </nav>

          {/* Auth Buttons */}
          <div className="flex gap-300 items-center w-[178px] shrink-0">
            <Button label="Sign in" variant="neutral" size="small" className="flex-1" />
            <Button label="Register" variant="primary" size="small" className="flex-1" />
          </div>
        </div>
      </header>

      {/* Mobile Header - exact Figma layout */}
      <header className="block desktop:hidden bg-background-default border-b border-border-default w-full">
        <div className="px-600 py-600 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-600">
            <img 
              src={figmaLogoMobile} 
              alt="Figma Logo" 
              className="h-[35px] w-[40px]"
            />
          </div>

          {/* Menu Button */}
          <button className="p-200 rounded-[32px] hover:bg-background-secondary transition-colors">
            <img 
              src={menuIcon} 
              alt="Menu" 
              className="h-[16px] w-[16px]"
            />
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;

